export const data = {
	heading: 'Совершенствовали инвестиционные продукты и продолжали развивать IT-систему',
	firstContent:
		'Наша цель — сделать простой, надёжный и доходный инвестиционный инструмент. Для этого мы проводили исследования, улучшали пользовательский опыт, дорабатывали модули в системе. Нам важно, чтобы клиенты получали одни из лучших финансовых продуктов на рынке.',
	listHeading: 'В 2020 году мы выпустили на рынок два инвестиционных продукта:',
	list: [
		'«Сбережения» — совместно с КПК «Фонд Ипотечного Кредитования».',
		'«Прямые инвестиции в бизнес» — на базе оператора инвестиционных платформ ООО «Кредит.Клаб».',
	],
	secondContent:
		'Тем самым мы упростили доступ к ранее практически недоступному высокодоходному инвестированию в залоговые займы для людей, у которых нет необходимой экспертизы.',
}
